
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userInfo"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentAuditPeriod"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"auditPeriodInfo"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"funds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hidden"},"value":{"kind":"BooleanValue","value":false}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimalRequirementsState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimalRequirementsStateChangeCounter"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initialMinimalEditAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initialStepModelEditAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stepModelRequirementsState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stepModel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precheck"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"userAttachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"attachmentInfo"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"auditorAttachments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"attachmentInfo"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":637}};
    doc.loc.source = {"body":"#import \"../fragments/userInfo.gql\"\n#import \"../fragments/auditPeriodInfo.gql\"\n#import \"../fragments/attachmentInfo.gql\"\n\nquery HomeQuery {\n  currentUser {\n    ...userInfo\n    currentAuditPeriod {\n      ...auditPeriodInfo\n      funds(hidden: false) {\n        id\n        name\n        state\n        minimalRequirementsState\n        minimalRequirementsStateChangeCounter\n        initialMinimalEditAt\n        initialStepModelEditAt\n        stepModelRequirementsState\n        stepModel\n        precheck\n      }\n      userAttachments {\n        ...attachmentInfo\n      }\n      auditorAttachments {\n        ...attachmentInfo\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/userInfo.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/auditPeriodInfo.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/attachmentInfo.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["HomeQuery"] = oneQuery(doc, "HomeQuery");
        
